import React, { useCallback, useState, useEffect } from 'react';

import {
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Box
} from '@chakra-ui/react';

const PasswordComponent = ({
  formTheme,
  dataId = null,
  fieldId,
  submitAttempted,
  defaultPlaceholder,
  fieldLabel,
  fieldValue,
  required,
  errorMessage,
  otherPasswordValue = ``,
  onChange = (value) => {},
  onReady = () => {}
}) => {
  const [isError, setIsError] = useState(required);
  const [isPasswordMismatch, setIsPasswordMismatch] = useState(false);

  const handleOnChange = useCallback(
    (value) => {
      const isInvalid = required === true && value.length < 6;
      setIsError(isInvalid);

      if (otherPasswordValue && value !== otherPasswordValue) {
        setIsPasswordMismatch(true);
      } else {
        setIsPasswordMismatch(false);
      }

      onChange({
        fieldId,
        dataId,
        value,
        label: fieldLabel,
        isValid: isInvalid === false
      });
    },
    [required, otherPasswordValue, onChange, fieldId, dataId, fieldLabel]
  );

  useEffect(() => {
    onReady({
      fieldId,
      required
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl
      mb="3"
      isInvalid={submitAttempted && (isError || isPasswordMismatch)}
      isRequired={required}>
      <FormLabel
        id={`field-label-text-${fieldId}-${fieldLabel}`}
        htmlFor={fieldId}
        mb="1.5">
        {fieldLabel}
      </FormLabel>
      <Input
        dataid={dataId}
        id={fieldId}
        name={fieldLabel}
        type="password"
        placeholder={fieldValue || defaultPlaceholder}
        onChange={(event) => handleOnChange(event.target.value)}
        onBlur={(event) => handleOnChange(event.target.value)}
      />
      {formTheme === `register` && (
        <Box fontSize="xs" mt="1">
          Min 6 characters
        </Box>
      )}
      {submitAttempted && isPasswordMismatch && (
        <FormErrorMessage>Passwords do not match.</FormErrorMessage>
      )}
      {submitAttempted && !isPasswordMismatch && isError && (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default PasswordComponent;
